const ApplyGradientOnBars = (context) => {
        //const { ctx, chartArea } = context.chart;

        const chart = context.chart; // chart instance
        const { ctx, chartArea } = chart; // ctx is real CanvasRenderingContext2D
        const { dataIndex, dataset } = context; // dataIndex & dataset come from context
        const options = chart.options;
        const chartType = context.chart.config.type;


        // chartArea is undefined on first call
        //if (!chartArea) return null;
        if (!chartArea) return undefined;


        let gradient = undefined;
        switch (chartType) {
          case "bar":
            if (options.indexAxis === 'x') gradient = ctx.createLinearGradient(
                          0, chartArea.bottom,
                          0, chartArea.top);
            else gradient = ctx.createLinearGradient(
                          chartArea.left, 0,
                          chartArea.right, 0);

          break;
          default:
            return;

        }

        //console.log(options.indexAxis)


        if (gradient) {
          //gradient.addColorStop(0, 'rgba(75,192,192,0.2)');
          //gradient.addColorStop(1, 'rgba(75,192,192,1)');
          gradient.addColorStop(0, dataset.gradientColors[0]);
          gradient.addColorStop(1, dataset.gradientColors[1]);
        }

        return gradient;
} 


export const ApplyGradientOrSolidColor = (chartConfig) => {
  //we need to the backgroundColor prop of every dataset
  //this can be a string with a single color or a string array with two colors
  // if it's a string array we need to apply a function to return a gradient
  //otherwise we leave it as a single color

  //To make more robust, if we find an array with only 1 color, we set that color as a solid color
  if (chartConfig.data == undefined || chartConfig.data.datasets == undefined) return

  for (const ds of chartConfig.data.datasets) {
    if (Array.isArray(ds.backgroundColor)) {
      ds.gradientColors = JSON.parse(JSON.stringify(ds.backgroundColor))
      ds.backgroundColor = ApplyGradientOnBars
    }
  }
}

export const backgroundPlugin = {
  id: 'customCanvasBackgroundColor',
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = options.color || '#fff';
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  }
};

function roundRect(ctx, x, y, width, height, radius) {
  const r = Math.min(radius, height / 2);

  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + width - r, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + r);
  ctx.lineTo(x + width, y + height - r);
  ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
  ctx.lineTo(x + r, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}
export const progressBackgroundPlugin = {
  id: 'progressBackground',

  beforeDatasetsDraw(chart, args, pluginOptions) {
    const { ctx, chartArea, scales } = chart;

    const xScale = scales.x;
    const yScale = scales.y;

    // assumes single horizontal bar
    const yValue = chart.data.labels[0];
    const y = yScale.getPixelForValue(yValue);

    const barThickness = pluginOptions.barThickness ?? 20;
    const radius = pluginOptions.borderRadius ?? 10;

    const xStart = xScale.getPixelForValue(xScale.min);
    const xEnd = xScale.getPixelForValue(xScale.max);

    ctx.save();
    ctx.fillStyle = pluginOptions.backgroundColor ?? '#e5e7eb';

    const height = barThickness;
    const top = y - height / 2;
    const width = xEnd - xStart;

    roundRect(ctx, xStart, top, width, height, radius);
    ctx.fill();

    ctx.restore();
  }
};

export const CenterBarLabelsPluginzzz = {
  id: 'centerBarLabels',

  afterDatasetsDraw(chart, args, options) {
    const { ctx } = chart;

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = options.color || '#000';
    //ctx.font = options.font || '12px Roboto';
    ctx.font = `${options.font.size}px ${options.font.family}`;

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      if (!meta || meta.type !== 'bar') return;

      meta.data.forEach((bar, index) => {
        const value = dataset.data[index];
        if (value == null) return;

        const x = (bar.x + bar.base) / 2;
        const y = bar.y;

        ctx.fillText(String(value), x, y);
      });
    });

    ctx.restore();
  }
};

export const CenterBarLabelsPlugin = {
  id: 'centerBarLabels',

  afterDatasetsDraw(chart, args, pluginOptions) {
    if (pluginOptions.display == false) return
    const { ctx } = chart;

    const {
      color = '#000',
      formatter = value => value,
      minBarSize = 0   // px; hide label if bar is smaller
    } = pluginOptions || {};

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = color;
    ctx.font = `${pluginOptions.font.size}px ${pluginOptions.font.family}`;

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      if (!meta || meta.type !== 'bar') return;

      meta.data.forEach((bar, index) => {
        const rawValue = dataset.data[index];
        if (rawValue == null) return;

        const barSize = Math.abs(bar.x - bar.base);
        if (barSize < minBarSize) return;

        const label = formatter(rawValue, {
          chart,
          dataset,
          datasetIndex,
          dataIndex: index
        });

        if (label == null || label === '') return;

        const x = (bar.x + bar.base) / 2;
        const y = bar.y;

        ctx.fillText(String(label), x, y);
      });
    });

    ctx.restore();
  }
};
